module.exports = __webpack_public_path__ + "img/category_sports__and__activities.dc64c47.png";